import React, { useState } from "react";
import { Container, Form } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { common } from "../js/common";

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    setError("");
    setIsLoading(true);
    try {
      const response = await common.fetchRestAPI("password-reset", "PUT", {
        token,
        password,
      });
      if (!response.ok) {
        const data = await response.json().catch(() => null);
        setError(data?.error || "Failed to reset password.");
        return;
      }
      setDone(true);
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="vh-100 mx-auto p-4" style={{ maxWidth: "576px" }}>
      <div
        className="d-flex flex-column justify-content-center"
        style={{ height: "100%" }}
      >
        <a href="/login">&lt; Back to login</a>
        <h1 className="text-center p-3">Choose a New Password</h1>

        {!token ? (
          <div className="alert alert-danger" role="alert">
            This reset link is missing its token.{" "}
            <a href="/forgot-password">Request a new one</a>.
          </div>
        ) : done ? (
          <div className="alert alert-success" role="alert">
            Your password has been reset. <a href="/login">Log in</a> with your
            new password.
          </div>
        ) : (
          <Form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                name="password"
                placeholder="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={8}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                name="confirmPassword"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                minLength={8}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={isLoading}>
              {isLoading ? "Saving..." : "Reset password"}
            </button>
            {error && (
              <div className="alert alert-danger mt-3" role="alert">
                {error}{" "}
                {/invalid|expired/i.test(error) && (
                  <a href="/forgot-password">Request a new link</a>
                )}
              </div>
            )}
          </Form>
        )}
      </div>
    </Container>
  );
}

export default ResetPasswordPage;
